import React, {useEffect, useRef, useState} from "react";
import { motion, progress } from "framer-motion";
import { useInView } from 'react-intersection-observer';
import AuxColumn from "../AuxColumn/AuxColumn";
import MobCreditComp from "../MobCreditComp/MobCreditComp";
import { workTags } from "../../globals/data";
import { isMobile } from "../../globals/helpers";
import { primaryInput } from "detect-it";
import { keywordVariants, metaVariants } from "./variants";
import Redacted from "../Redacted/Redacted";

const MetaCreditComponent = ({data, isSecondaryView, scroller, creditSectionRef}) => {
    const positionRef = useRef(null);
    const { ref: secondarySecRef, inView: secondMetaInView } = useInView({
        triggerOnce: true, // Trigger only once when entering the viewport
        threshold: 0.5, // Trigger when 50% of the element is in view (adjust this based on your needs)
    });

    const [startedInView, setStartedInView] = useState(null);

    const secondaryMobVariants = {
        initial: {
            opacity: 0
        }, animate: (i) => ({
            opacity: 1,
            transition: {
                delay: i,
                duration: 1,
                ease: "easeIn"
            }
        }), exit: {
            opacity: 0
        }
    }

    useEffect(() => {
        if(primaryInput !== "mouse"){
            if(secondMetaInView){
                let scroll = document.documentElement.scrollTop;
                if(scroll < 1) setStartedInView(true);
                else setStartedInView(false);
            }
        }else{
            if(scroller){
                if(secondMetaInView){
                    let test = scroller;
                    let translateY = scroller.scroll.instance.scroll.y;
                    if(translateY == 0)setStartedInView(true);
                    else setStartedInView(false)
                } else{
                    setStartedInView(false)
                }
            }
        }
    }, [secondMetaInView, scroller])

    return(
        !isSecondaryView ? 
            <div ref={creditSectionRef}>
                <motion.div 
                    key={"aux-in-view-"+isSecondaryView}
                    className="secondary_meta__wrapper"
                    initial="initial"
                    animate={secondMetaInView || !startedInView ? "animate" : "initial"}
                    exit="exit"
                    variants={metaVariants}
                    ref={secondarySecRef}
                >
                    {
                        startedInView !== null &&
                        <>
                            <div className="sm_left" ref={positionRef}>
                                <AuxColumn 
                                    secTitle={'CREDIT'}
                                    payload={data.credits}
                                    baseDelay={startedInView ? 0.15 : 0}
                                />
                                <div className="sm_keywords__wrapper">
                                    {
                                        data.keywords.map((item, idx) => (
                                            <motion.span
                                                className="keyword_item"
                                                variants={keywordVariants}
                                                custom={idx}
                                            >
                                                {item}
                                            </motion.span>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="sm_right">
                                <div className="sm_description__wrapper">
                                    <motion.span
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"
                                        style={{
                                            position: "relative"
                                        }}
                                    >
                                        {data.description}
                                        <Redacted delay={0.3} duration={1}/>
                                    </motion.span>
                                </div>
                                {
                                    data.feature !== null && window.innerWidth <= 1000 &&
                                    <>
                                        <div className="feature_wrapper">
                                            <Redacted delay={0.3} duration={1}/>
                                            <span>FEATURING&nbsp;</span>
                                            {data.feature.map((item, idx) => (
                                                idx == 0 ?
                                                    <span>{item}</span>
                                                :
                                                    <span>&nbsp;&&nbsp;{item}</span>
                                            ))}
                                        </div>
                                    </>
                                }
                                <div className="meta_info_row__wrapper">
                                    <AuxColumn
                                        secTitle={null}
                                        payload={data.meta}
                                        showKeys={false}
                                        baseDelay={startedInView ? 0.45 : 0}
                                    />
                                    {
                                        data.feature !== null && window.innerWidth > 1000 &&
                                        <>
                                            <div className="feature_wrapper">
                                                <Redacted delay={0.3} duration={1}/>
                                                <span>FEATURING&nbsp;</span>
                                                {data.feature.map((item, idx) => (
                                                    idx == 0 ?
                                                        <span>{item}</span>
                                                    :
                                                        <span>&nbsp;&&nbsp;{item}</span>
                                                ))}
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                            
                        </>
                    }
                </motion.div>
            </div>
        :
        
            <div
                className="secondary_meta_mob__wrapper"
                ref={secondarySecRef}
            >
                <div className="meta-mob-bkp" ref={creditSectionRef}>
                    { startedInView !== null &&
                        <motion.div
                            initial="initial"
                            animate={secondMetaInView ? "animate" : "initial"}
                            exit="exit"
                            variants={secondaryMobVariants}
                            custom={startedInView ? 0.5 : 0}
                        >
                            <div className="mob_credits__wrapper" ref={positionRef}>
                                <MobCreditComp 
                                    metaName={"CREDITS"}
                                    payload={data.credits}
                                    delay={0.25}
                                />
                                <div className="mob-proj-desc">
                                    
                                    <motion.span
                                        initial={{
                                            opacity: 0
                                        }}animate={{
                                            opacity: 1,
                                            transition: {
                                                duration: 0.55,
                                                delay: 0.45,
                                                ease: "easeIn"
                                            }
                                        }}exit={{
                                            opacity: 0
                                        }}
                                    >
                                        <Redacted delay={0.3} duration={1}/>
                                        {data.description}
                                    </motion.span>
                                </div>

                                <MobCreditComp 
                                    showKeys={false}    
                                    payload={data.meta}
                                    delay={0.35}
                                />
                                <motion.div className="mob-keywords__wrapper">
                                    {data.keywords.map((item, idx) => (
                                        <motion.span
                                            initial={{
                                                opacity: 0
                                            }}animate={{
                                                opacity: 1,
                                                transition: {
                                                    duration: 0.55,
                                                    delay: 0.45,
                                                    ease: "easeIn"
                                                }
                                            }}exit={{
                                                opacity: 0
                                            }}
                                        >
                                            {item}
                                        </motion.span>
                                    ))}
                                </motion.div>
                            </div>
                        </motion.div>
                    }
                </div>
            </div>
    )
}

export default MetaCreditComponent